"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generateMetrics_1 = require("../../Shaka/generateMetrics");
function registerHttpRequestMonitorCallbacks(httpRequestMonitor, abrManager, videoElement, player) {
    httpRequestMonitor.on('bandwidth-estimate', function (bandwidthEstimate) {
        var metrics = generateMetrics_1.default(videoElement, player, bandwidthEstimate);
        abrManager.onMetrics(metrics);
    });
    httpRequestMonitor.on('timeout', function () {
        abrManager.onTimeout();
    });
}
exports.default = registerHttpRequestMonitorCallbacks;
//# sourceMappingURL=registerHttpRequestMonitorCallbacks.js.map